import React, { Component } from 'react';
import { get } from "lodash";
import TooltipWithIcon from '../Tooltip/WithIcon';
import FormGroup from './FormGroup';
import style from './style.module.css';

export default class Checkbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checkValue === props.input.value
        }
    }

    componentDidUpdate(prevProps) {
        const { input, checkValue } = this.props;
        if (get(prevProps, "input.value") !== input.value) {
            this.setState({
                checked: checkValue === input.value
            })
        }
    }

    render() {
        const { id, label, input, meta, checkValue, disabled = false, tooltip = false, mainLabel = false } = this.props;
        return (
            <FormGroup
                label={mainLabel}
                disabled={disabled}
                meta={meta}
                className="checkbox"
                fieldName={input.name}
                fieldValue={checkValue}
            >
                <label htmlFor={id} className={`${style.checkbox}`}>
                    <input
                        type="checkbox"
                        onChange={this.onChangeHandler}
                        checked={input.value === checkValue}
                        className={style.checkboxInput}
                        disabled={disabled}
                        id={id}
                    />
                    <div className={`${style.checkboxSquare}`}></div>
                    {
                        label && (
                            <div className={`${style.checkboxText}`} dangerouslySetInnerHTML={{__html: label}}></div>
                        )
                    }
                    {
                        tooltip !== false && (
                            <TooltipWithIcon {...this.props}>{tooltip}</TooltipWithIcon>
                        )
                    }
                </label>
            </FormGroup>
        )
    }

    onChangeHandler = () => {
        const { input: { onChange, onBlur }, checkValue, offValue = false, onCheckChange = () => { } } = this.props;
        const { checked } = this.state;
        onBlur()
        if (offValue !== false) {
            // If you need number value like property = 0
            const v = checked ? offValue : checkValue;
            onChange(v);
            onCheckChange(v);
        }
        else {
            const val = checked ? "" : checkValue;
            onChange(val);
            onCheckChange(val);
        }
        this.setState({
            checked: !checked
        })
    }
}